import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/companies',
      method: 'get',
      params: params
  })
}
export function getCompaniesInfo(params) {
  return request({
      url: '/settings/info/company',
      method: 'get',
      params: params
  })
}
export function inventory(params) {
  return request({
      url: '/settings/company/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/settings/companies/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/companies',
      method: 'post',
      data
  })
}

export function update(data) { 
  return request({
      url: `/settings/companies/update/${data.id}`,
      method: 'post',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/companies/${id}`,
      method: 'delete',
  })
}
